import { fetchClient } from '../axiosinterceptor';

export const getUserGuests = async ({ page, limit, userId }) => {
	const { data } = await fetchClient().get(`users/${userId}/guests/limit/${limit}/page/${page}`);
	return data;
}